var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 -3 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5236 7.08594H2.41879C2.20927 7.08594 2.03784 7.25737 2.03784 7.46689V12.6859C2.03784 12.8955 2.20927 13.0669 2.41879 13.0669H21.5236C21.7331 13.0669 21.9045 12.8955 21.9045 12.6859V7.46689C21.9045 7.25737 21.7331 7.08594 21.5236 7.08594ZM5.67594 11.7907C4.76165 11.7907 4.01879 11.0478 4.01879 10.1336C4.01879 9.21927 4.76165 8.47641 5.67594 8.47641C6.59022 8.47641 7.33308 9.21927 7.33308 10.1336C7.35213 11.0478 6.60927 11.7907 5.67594 11.7907ZM15.2378 11.0859C15.2378 11.1431 15.1807 11.2002 15.1236 11.2002H8.83784C8.7807 11.2002 8.72355 11.1431 8.72355 11.0859V9.08594C8.72355 9.02879 8.7807 8.97165 8.83784 8.97165H15.1236C15.1807 8.97165 15.2378 9.02879 15.2378 9.08594V11.0859ZM18.2664 11.7907C17.3521 11.7907 16.6093 11.0478 16.6093 10.1336C16.6093 9.21927 17.3521 8.47641 18.2664 8.47641C19.1807 8.47641 19.9236 9.21927 19.9236 10.1336C19.9236 11.0478 19.1807 11.7907 18.2664 11.7907Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.26661 17.4071C4.26661 17.4833 4.32375 17.5404 4.39994 17.5404H6.97137C7.04756 17.5404 7.1047 17.4833 7.1047 17.4071V14.0547H4.24756V17.4071H4.26661Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8381 17.4071C16.8381 17.4833 16.8953 17.5404 16.9715 17.5404H19.5429C19.6191 17.5404 19.6762 17.4833 19.6762 17.4071V14.0547H16.8191V17.4071H16.8381Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9048 3.12381H21.2952V3.67619H19.6952L18.5905 0H5.37143L4.26667 3.67619H2.70476V3.12381H0.0952381C0.0380952 3.12381 0 3.1619 0 3.21905V5.10476C0 5.1619 0.0380952 5.2 0.0952381 5.2H2.70476V4.64762H3.9619L3.52381 6.09524H5.94286L6.8 1.65714H17.1429L18 6.09524H20.419L19.981 4.64762H21.2952V5.2H23.9048C23.9619 5.2 24 5.1619 24 5.10476V3.21905C24 3.18095 23.9619 3.12381 23.9048 3.12381Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarW);
export default __webpack_public_path__ + "static/media/CarW.baa00c404d3ba9a23696d628d09db023.svg";
export { ForwardRef as ReactComponent };